import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Ferme les autres instances de app-dropdown-select lorsqu’une liste s’ouvre.
 */
@Injectable({ providedIn: 'root' })
export class DropdownSelectCoordinatorService {
  private readonly openedInstanceId = new Subject<string>();

  /** Identifiant d’instance émis à chaque ouverture de liste. */
  readonly openedInstanceId$ = this.openedInstanceId.asObservable();

  notifyOpened(instanceId: string): void {
    this.openedInstanceId.next(instanceId);
  }
}
